module.exports = __webpack_public_path__ + "img/advantage1Red.290da608.png";